import React, { useState } from "react";
import style from "./PlanTemplates.module.sass";
import List from "../List/List";
import PlanTemplatesHeader from "./PlanTemplatesHeader/PlanTemplatesHeader";
import { callApi } from "../../helpers";
import ButtonSelect from "../ButtonSelect/ButtonSelect";
import PlanTemplateItem from "./PlanTemplateItem/PlanTemplateItem";
import Button from "../Button/Button";

function PlanTemplates(props) {
  const {
    items,
    translations,
    urls,
  } = props;

  const [createPlanUrl, setCreatePlanUrl] = useState(null);
  const [queryUrl, setQueryUrl] = useState(urls.planTemplatesUrl);
  const [openItemName, setOpenItemName] = useState(null);

  const onChangeFilter = (search = "") => {
    setQueryUrl(urls.planTemplatesUrl + "&name=" + search);
  };

  const onClickPhase = (url) => {
    setCreatePlanUrl(url);
  }

  const onClickCreate = () => {
    if (!createPlanUrl) {
      console.error("No create plan URL set. Please select a plan template first.");
      return;
    }
    callApi(
      createPlanUrl, "POST", 'json',
      (response) => {
        console.log("onClickCreate response", response);
        window.location.href = response.redirectUrl;
      },
    );
  }

  const renderItem = (item) => {
    return (
      <PlanTemplateItem
        {...item}
        onClickPhase={onClickPhase}
        key={item.name}
        openItemName={openItemName}
        setOpenItemName={setOpenItemName}
      />
    );
  };


  const renderCreateBtn = () => {
    return (
      <div className={`${style.createBtn}`}>
        <div className={`no-link`}>
          <div className={`custom-height-similar`}>
            <div className={createPlanUrl ? `clickable ${style.active}` : style.disabled}
              onClick={onClickCreate}>
              {translations.useTemplate}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`${style.PlanTemplates}`}>
      <div className={`${style.filters}`}>
        <div className={style.title}>
          <Button kariBtnWhite href={urls?.backUrl}>
            {translations?.back}
          </Button>
          {translations.pageTitle}
        </div>
        <PlanTemplatesHeader
          onChangeFilter={onChangeFilter}
          searchPlaceholder={translations.searchPlaceholder}
        />
        {renderCreateBtn()}
      </div>
      <div className={style.plans}>
        {/* {[LICENSES].map((queryUrl) => { */}
        {/* return ( */}
        <List
          baseQuery={queryUrl}
          renderItem={renderItem}
          showPagination={false}
        />
        {/* ); */}
        {/* })} */}
      </div>
    </div>
  );
}

PlanTemplates.propTypes = {};

PlanTemplates.defaultProps = {};

export default PlanTemplates;
